<img class="icon"
     src="{{src}}"
     alt="アイコン画像"
     width="{{size}}"
     height="{{size}}"
     (error)="setDefaultProfileIcon($event)"
/>
